import { connect } from 'react-redux';
import ProductsView from '../../../components/products/ProductsView';
import {
  searchResults,
  searchResultsFilter,
  loadingSearch,
  currentStore,
  currentStoreName,
  currentChain,
  searchReportOptions,
  searchReportOptionsLoading,
  searchReportOptionsFetchedStore,
} from 'core/selectors';
import { getLayout } from 'core/slices/aisles';
import {
  searchProduct,
  setSearchFilter,
  resetSearchFilter,
  resetSearch,
  restoreSearch,
  fetchReportOptions,
} from 'core/slices/search';

export default connect(
  (state) => ({
    searchResults: searchResults(state),
    searchResultsFilter: searchResultsFilter(state),
    loadingSearch: loadingSearch(state),
    currentStore: currentStore(state),
    currentStoreName: currentStoreName(state),
    currentChain: currentChain(state),
    reportOptions: searchReportOptions(state),
    reportOptionsLoading: searchReportOptionsLoading(state),
    reportOptionsFetchedStore: searchReportOptionsFetchedStore(state),
  }),
  {
    searchProduct,
    setSearchFilter,
    resetSearchFilter,
    resetSearch,
    restoreSearch,
    fetchReportOptions,
    getLayout,
  },
)(ProductsView);
